import { Images } from 'assets/images/images.index';
import { ItemList } from 'components/atoms/Item-list/Item-list';
import { Link } from 'components/atoms/Link/Link';
import { useState } from 'react';
import '../Accordion-detail/Accordion-detail.scss';

export interface IAccordionItem {
  name: string;
}

interface IAccordionDetailProps {
  title?: string;
  titleTermsAndConditions?: string;
  data: IAccordionItem[];
  defaultOpen?: boolean;
  url_policies: string;
}

export const AccordionDetailWithoutTap = ({
  title = '¿Qué incluye?',
  titleTermsAndConditions = 'Ver detalles del contrato',
  data,
  defaultOpen = false,
  url_policies,
}: IAccordionDetailProps) => {
  const [isHiddenDetail, setIsHiddenDetail] = useState(!defaultOpen);

  return (
    <div
      className={`accordion__detail__container ${
        isHiddenDetail ? '' : 'is--open'
      }`}
    >
      <Link
        size="s"
        label={isHiddenDetail ? title : 'Ver menos'}
        type={isHiddenDetail ? 'primary' : 'secondary'}
        rightIcon
        onClick={() => setIsHiddenDetail(!isHiddenDetail)}
      />
      {!isHiddenDetail && (
        <div className="accordion__detail__content">
          <div className="accordion__detail__container__list">
            <span>Servicios que incluye</span>
            <div className="accordion__detail__content__list">
              {data.map((item, index) => (
                <ItemList key={index}>{item.name}</ItemList>
              ))}
            </div>
          </div>
          <div className="accordion__detail__more__info">
            <img src={Images.personaCel} alt="Información" />
            <span>
              Para más información <br />
              <a target="_blank" rel="noreferrer" href={url_policies}>
                {titleTermsAndConditions}
              </a>
            </span>
          </div>
        </div>
      )}
    </div>
  );
};
